import { render, staticRenderFns } from "./UserPersonalCardTable.vue?vue&type=template&id=016164bb&"
import script from "./UserPersonalCardTable.vue?vue&type=script&lang=js&"
export * from "./UserPersonalCardTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports